import StepsImage from '@/assets/Onboarding/StepsImage.png';
import { Button } from '@/components/ui/button';
import { PatientPageLayout } from '@/components/PatientPageLayout';

export const IneligiblePage = () => {
  return (
    <PatientPageLayout
      title={
        <div className="flex flex-col items-center gap-4">
          <img
            src={StepsImage}
            alt="Mon bilan prévention"
            className="size-40"
            width="160"
            height="160"
          />
          <p className="text-1.5xl text-center font-medium">
            Vous n&apos;êtes pas éligible
          </p>
        </div>
      }
      footer={
        <div className="flex w-full flex-col items-center mx-auto">
          <Button
            variant="ctaSecondary"
            size="lg"
            onClick={() =>
              window.open(
                'https://sante.gouv.fr/prevention-en-sante/preserver-sa-sante/mon-bilan-prevention-les-rendez-vous-sante-aux-ages-cles-de-la-vie/article/mon-bilan-prevention-en-quoi-ca-consiste',
                '_blank',
              )
            }
          >
            En savoir plus
          </Button>
        </div>
      }
    >
      <div className="flex w-full flex-col items-center gap-6 px-8 nsm:px-14">
        <p className="text-center leading-5 font-light">
          Le dispositif <span className="italic">Mon bilan prévention</span> est
          réservé aux personnes entrant dans ces tranches d&apos;âge :
        </p>
        <div className="flex items-center justify-center w-full border rounded-xl border-gray-200 px-2 py-4 gap-8">
          <div className="font-light">
            <p className="text-sm">
              <span className="font-medium">18-25</span> ans
            </p>
            <p className="text-sm">
              <span className="font-medium">60-65</span> ans
            </p>
          </div>
          <div>
            <p className="text-sm">
              <span className="font-medium">45-50</span> ans
            </p>
            <p className="text-sm">
              <span className="font-medium">70-75</span> ans
            </p>
          </div>
        </div>
        <p className="text-center leading-5 font-light">
          Vous pouvez tout de même consulter votre médecin pour votre suivi
          habituel.
        </p>
      </div>
    </PatientPageLayout>
  );
};
